<template>
   <Tooltip placement="top" :content="tip||disabledTip" :disabled="!tip" :delay="delay || 1000">
    <svg
      class="iconfont"
      :style="style"
      aria-hidden="true"
      @click="_click($event)"
      @mouseenter="_mouseenter"
      @mouseleave="_mouseleave"
      @mousedown="_mousedown"
    >
      <use :xlink:href="`#${icon}`"></use>
    </svg>
   </Tooltip>
</template>
<script>
export default {
  name: 'Iconfont',
  props: {
    icon: String,
    color: String,
    size: {
      type: [String, Number]
    },
    hoverColor: String,
    activedColor: String,
    handleColor: String,
    delay: Number,
    tip: String,
    disabled: Boolean
  },
  data(){
    return {
      disabledTip: false,
      isHover: false,
      isActived: false,
      defaultColor: {
        default: {
          hover: '#04cbd8',
          actived: '#2b9da2'
        },
        delete: {
          hover: '#F94742',
          actived: '#ba302c'
        }
      }
    }
  },
  computed: {
    style() {
      let color = this.color
      if(this.isActived){
        if(this.handleColor){
          color = this.defaultColor[this.handleColor].actived
        }else{
          color = this.activedColor
        }
      }else{
        if(this.handleColor){
          color = this.isHover?this.defaultColor[this.handleColor].hover:this.color
        }else{
          color = this.isHover?this.hoverColor:this.color
        }
      }
      if(this.disabled){
        return {
          fontSize: typeof this.size === 'string' ? this.size : this.size + 'px',
          color: '#9999A4',
          cursor: 'default'
        }
      }
      return {
        fontSize: typeof this.size === 'string' ? this.size : this.size + 'px',
        color
      }
    }
  },
  methods: {
    _click(e){
      if(this.disabled) return
      this.disabledTip = true
      this.$emit('click', e)
    },
    _mouseenter(){
      if(this.hoverColor || this.handleColor){
        this.isHover = true
        this.disabledTip = false
      }
    },
    _mouseleave(){
      if(this.hoverColor || this.handleColor){
        this.isHover = false
      }
    },
    _mousedown(){
      if(this.activedColor || this.handleColor){
        this.isActived = true
        document.onmouseup = () => {
          this.isActived = false
          document.onmouseup = null
        }
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.iconfont
  width 1em
  height 1em
  vertical-align -0.15em
  fill currentColor
  overflow hidden
</style>

